<template lang="pug">
.tooltip(@mouseenter="visible = true" @mouseleave="visible = false")
	slot
	span.tooltiptext(v-show="visible") {{ text }}
</template>

<script>
export default {
	props: {
		text: {
			type: String,
			required: true
		}
	},
	data: () => ({
		visible: false
	})
};
</script>

<style lang="stylus" scoped>
.tooltip
	position relative
	display inline-block

	.tooltiptext
		max-width 160px
		background-color $dark-bg-color
		color $dark-bg-text-color
		text-align center
		padding 1em
		position absolute
		z-index 9999
		bottom 125%
		left 50%
		margin-left -25px
		opacity 1
		text-transform none
</style>
